import React from 'react';
const FormFieldError = ({
  message,
  isVisible,
  className,
  icon,
  dataTestId = ''
}) => {
  if (isVisible) {
    return /*#__PURE__*/React.createElement("p", {
      className: `
          ${className ?? ''}
          text-red-600
          text-sm
        `,
      "data-testid": dataTestId
    }, icon, message);
  }
  return null;
};
export default FormFieldError;